<div class='gallery-item-container'>
  <vrm-map
    class='gallery-item'
    *ngIf='item.map'
    [latitude]='item.map.latitude'
    [longitude]='item.map.longitude'
    [interactive]='false'
  ></vrm-map>
  <img
    class='gallery-item optanon-category'
    data-ot-ignore
    *ngIf='item.media?.mediaType === mediaTypes.image'
    [src]='item.media.imageStream'
  />
  <video
    class='gallery-item'
    *ngIf='item.media?.mediaType === mediaTypes.video'
    controls
    controlsList='nodownload nofullscreen'
  >
    <source [src]='item.media.imageStream' type='video/mp4' />
  </video>
  <div class='gallery-item audio-item' *ngIf='item.media?.imageStream && item.media?.mediaType === mediaTypes.audio'>
    <audio [src]='item.media.imageStream | trustAsSafeUrl' controls controlsList='nodownload'></audio>
  </div>

  <div class='gallery-item document-icon' *ngIf='item.media?.mediaType === mediaTypes.document'>
    <div class='no-preview-item'>
      <img
        *ngIf='item.media.fileTypeIcons?.blue'
        [src]='item.media.fileTypeIcons?.blue'
        class='padding-b-5'
        width='60px'
        height='60px'
      />
      <p>
        <a
          class='link-to-file'
          [href]='item.media.imageStream | trustAsSafeUrl'
          [download]='item.media.documentTitle'
        >
          {{ item.media.documentTitle }}</a
        >
      </p>
      <p>
				<span class='no-preview-guide'>
					{{ 'DER.noPreviewGuide' | translate }}
				</span>
      </p>
    </div>
  </div>
  <div class='item-overlay' *ngIf='!item.map && item.media?.mediaType !== mediaTypes.video'>
    <a class='download-icon' [href]='item.media.imageStream | trustAsSafeUrl' [download]='item.media.documentTitle'>
      <mat-icon class='padding-l-5 padding-r-5'> file_download</mat-icon>
    </a>
  </div>
</div>
